<template>
   <div v-if="isResendModalShown">
       <loading-component v-if="isLoading"></loading-component>
        <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
            <div class="modal-dialog">
                <div class="modal-content" style="margin-top: 150px">
                    <div class="modal-body" v-if="ResetStatus" >
                        <div class="close_btn" v-on:click="CloseModal()"></div>
                        <!-- <div v-if="ResetForm"> 
                            <div class="passwordReset-header">
                                <p class="modal-title">Resend your activation email</p>
                                <p class="modal-description"></p>
                            </div>
                            <div class="u-shadow-v35 g-bg-white rounded g-px-40 g-py-50">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label class="reset_info_label">Enter your Email Address</label>
                                        <input name="email" type="email" class="form-control login_input" v-on:keyup="ResetValidation()" v-model="RequestEmail" v-validate="'required|email'" data-vv-as="email address">
                                        <p class="error-message" v-show="errors.has('email')">{{ errors.first('email') }}</p>
                                        <p v-if="!errors.first('email')" class="error-message">{{errorMessage}}</p>
                                    </div>
                                 
                                    <div class="form-group">
                                      <button v-on:click="ResendActivation()" class="btn btn-default login_button u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-">Resend Activation Email</button>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div>
                        <div class="passwordReset-header">
                            <p class="modal-title">Success!</p>
                            <p class="modal-description">A new activation email has been sent to you. Please check your inbox.</p>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="passwordReset-header">
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
   </div>
</template>
<script>
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
      props: [
    "RequestEmail"],
    components: {LoadingComponent},
    data() {
        return {
            isResendModalShown: true,
            //RequestEmail: "",
            errorMessage: null,
            ResetStatus: false,
            ResetForm: true,
            isLoading: false

        }
    },
    methods: {
        CloseModal() {
            this.isResendModalShown = false;
            this.$emit("clicked");
            document.body.classList.remove("body-overflow");
        },
        ResetValidation(){
            this.errorMessage= "";
        },
        ResendActivation() {
            this.isLoading = true;
            axios.post("/Account/ResendActivation/" + this.RequestEmail, { "headers": { "Content-Type": "application/json"  } })
                .then(response => {
                var _this = this;
                _this.isLoading = false;
                if (response.data.isSuccess == true) {
                    _this.ResetForm = !_this.ResetForm;
                    _this.ResetStatus = !_this.ResetStatus;

                } else {
                    _this.errorMessage = response.data.errorMessage;
                    console.log(response.data.errorMessage);
                }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    created(){
        this.ResendActivation();
    }
}
</script>



// WEBPACK FOOTER //
// ResendActivation.vue?1e2fd840